import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { SelectUsersDialogModule } from 'app/projects/user/src/lib/components/select-users-dialog/select-users-dialog.module';
import { MaxBrainModuleUserModule } from '../module-user/module-user.module';
import { CourseOfferingParticipantsApiService } from './services/course-offering-participants.api-service';
import { CourseOfferingParticipantsService } from './services/course-offering-participants.service';
import { AddBookingsDialogComponent } from './components/dialogs/add-bookings-dialog/add-bookings-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { AddProgramParticipantsDialogComponent } from './components/dialogs/add-program-participants-dialog/add-program-participants-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { RemoveProgramParticipantsDialogComponent } from './components/dialogs/remove-program-participants-dialog/remove-program-participants-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AddCourseOfferingBookingsDialogComponent } from './components/dialogs/add-course-offering-bookings-dialog/add-course-offering-bookings-dialog.component';
import { CourseOfferingParticipantListComponent } from './components/list/course-offering-participants-list/list.component';

@NgModule({
    imports: [
        RouterModule,
        MatCheckboxModule,
        MatTableModule,
        MatMenuModule,
        MatCardModule,
        MatIconModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatInputModule,
        MatButtonModule,
        MatAutocompleteModule,
        MaxBrainSharedModule,
        MatChipsModule,
        SelectUsersDialogModule,
        MaxBrainModuleUserModule,
        MatSortModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatSelectModule,
        MatTooltipModule,
        MatStepperModule,
        MatExpansionModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
    ],
    declarations: [
        CourseOfferingParticipantListComponent,
        AddBookingsDialogComponent,
        AddProgramParticipantsDialogComponent,
        RemoveProgramParticipantsDialogComponent,
        AddCourseOfferingBookingsDialogComponent,
    ],
    exports: [
        CourseOfferingParticipantListComponent,
        AddBookingsDialogComponent,
        AddProgramParticipantsDialogComponent,
        RemoveProgramParticipantsDialogComponent,
        AddCourseOfferingBookingsDialogComponent,
    ],
    providers: [CourseOfferingParticipantsService],
})
export class CourseOfferingParticipantsModule {
    static forRoot(): ModuleWithProviders<CourseOfferingParticipantsModule> {
        return {
            ngModule: CourseOfferingParticipantsModule,
            providers: [CourseOfferingParticipantsApiService],
        };
    }
}
